import { createSelector } from 'reselect';

const getState = (state) => state.mrCollection.ui;

const getIsFetching = createSelector(getState, (ui) => ui.isFetching);

const getIsSubmitting = createSelector(getState, (ui) => ui.isSubmitting);

export default {
  getIsFetching,
  getIsSubmitting,
};
